// extracted by mini-css-extract-plugin
export default {"container":"DefaultErrorFallback_container__HbRtr"};